module.exports = __webpack_public_path__ + "media/images/icon_external_link-b412fd1567d16da97d228e81a9df95a1.png";